import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 内容&公共部分
 *
 */

// // 调剂名单   @@@@@@@  调取不成功
// export const searchRecruitPrepare = (query) => {
//   return request({
//     url: `${prefix}/college/adjustVip/searchRecruitPrepare/list`,
//     method: 'get',
//     params: query
//   })
// }



// // 调剂报告详情   @@@@@@@@@  调取不成功
// export const searchAnalyseInfo = (query) => {
//   return request({
//     url: `${prefix}/college/adjustVip/searchAnalyseInfo`,
//     method: 'get',
//     params: query
//   })
// }
// 调剂名单   @@@@@@@  调取不成功
export const searchRecruitPrepare = (query) => {
  return request({
    url: `${prefix}/adjust26/vip/recruitPrepare/list`,
    method: 'get',
    params: query
  })
}



// 调剂报告详情   @@@@@@@@@  调取不成功
export const searchAnalyseInfo = (query) => {
  return request({
    url: `${prefix}/adjust26/vip/analyseInfo`,
    method: 'get',
    params: query
  })
}



// 调剂报告
// export const recommendReport = (query) => {
//   return request({
//     url: `${prefix}/college/adjustSVip/recommendReport`,
//     method: 'get',
//     params: query
//   })
// }
//调剂报告
export const recommendReport = (query) => {
  return request({
    url: `${prefix}/adjust26/svip/recommendReport`,
    method: 'get',
    params: query
  })
}



// 调剂用户信息查询
export const userInfo = (query) => {
  return request({
    url: `${prefix}/college/adjust/userInfo`,
    method: 'get',
    params: query
  })
}

// 修改调剂用户
export const userInfoUp = (query) => {
  return request({
    url: `${prefix}/college/adjust/userInfo`,
    method: 'put',
    data: query
  })
}



// 调剂报告查询无用户版接口 

// export const recommendReportNoneUser = (query) => {
//   return request({
//     url: `${prefix}/college/adjustSVip/recommendReportNoneUser`,
//     method: 'post',
//     data: query
//   })
// }
export const recommendReportNoneUser = (query) => {
  return request({
    url: `${prefix}/adjust26/svip/recommendReportNoneUser`,
    method: 'post',
    data: query
  })
}

/**
* 平台快递列表
* @param {*} query
*/
export const expressList = (query) => {
  return request({
    url: `${prefix}/express/list`,
    method: 'get',
    params: query
  })
}

/**
 * 省份信息列表
 * @param {*} query
 */
export const provinceList = (query) => {
  return request({
    url: `${prefix}/province/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校查询：列表
 * @param {*} query
 */
export const collegeList = (query) => {
  return request({
    url: `${prefix}/college/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校查询
 * @param {*} query
 */
export const collegeOne = (query) => {
  return request({
    url: `${prefix}/college`,
    method: 'get',
    params: query
  })
}

/**
 * 院校创建
 * @param {*} query
 */
export const collegeCreate = (query) => {
  return request({
    url: `${prefix}/college`,
    method: 'post',
    data: query
  })
}

/**
 * 院校修改
 * @param {*} query
 */
export const collegeUpdate = (query) => {
  return request({
    url: `${prefix}/college`,
    method: 'put',
    data: query
  })
}

/**
 * 院校删除
 * @param {*} query
 */
export const collegeDestroy = (query) => {
  return request({
    url: `${prefix}/college`,
    method: 'delete',
    data: query
  })
}

/**
 * 院校分类查询：列表
 * @param {*} query
 */
export const collegeCategoryList = (query) => {
  return request({
    url: `${prefix}/college/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校分类查询
 * @param {*} query
 */
export const collegeCategoryOne = (query) => {
  return request({
    url: `${prefix}/college/category`,
    method: 'get',
    params: query
  })
}

/**
 * 院校分类创建
 * @param {*} query
 */
export const collegeCategoryCreate = (query) => {
  return request({
    url: `${prefix}/college/category`,
    method: 'post',
    data: query
  })
}

/**
 * 院校分类修改
 * @param {*} query
 */
export const collegeCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/college/category`,
    method: 'put',
    data: query
  })
}

/**
 * 院校分类删除
 * @param {*} query
 */
export const collegeCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/college/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 学院查询：列表
 * @param {*} query
 */
export const academyList = (query) => {
  return request({
    url: `${prefix}/academy/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学院查询
 * @param {*} query
 */
export const academyOne = (query) => {
  return request({
    url: `${prefix}/academy`,
    method: 'get',
    params: query
  })
}

/**
 * 学院创建
 * @param {*} query
 */
export const academyCreate = (query) => {
  return request({
    url: `${prefix}/academy`,
    method: 'post',
    data: query
  })
}

/**
 * 学院修改
 * @param {*} query
 */
export const academyUpdate = (query) => {
  return request({
    url: `${prefix}/academy`,
    method: 'put',
    data: query
  })
}

/**
 * 学院删除
 * @param {*} query
 */
export const academyDestroy = (query) => {
  return request({
    url: `${prefix}/academy`,
    method: 'delete',
    data: query
  })
}

/**
 * 专业查询：列表
 * @param {*} query
 */
export const majorList = (query) => {
  return request({
    url: `${prefix}/major/list`,
    method: 'get',
    params: query
  })
}

/**
 * 专业查询
 * @param {*} query
 */
export const majorOne = (query) => {
  return request({
    url: `${prefix}/major`,
    method: 'get',
    params: query
  })
}

/**
 * 专业创建
 * @param {*} query
 */
export const majorCreate = (query) => {
  return request({
    url: `${prefix}/major`,
    method: 'post',
    data: query
  })
}

/**
 * 专业修改
 * @param {*} query
 */
export const majorUpdate = (query) => {
  return request({
    url: `${prefix}/major`,
    method: 'put',
    data: query
  })
}

/**
 * 专业删除
 * @param {*} query
 */
export const majorDestroy = (query) => {
  return request({
    url: `${prefix}/major`,
    method: 'delete',
    data: query
  })
}

/**
 * 科目查询：列表
 * @param {*} query
 */
export const subjectList = (query) => {
  return request({
    url: `${prefix}/subject/list`,
    method: 'get',
    params: query
  })
}

/**
 * 科目查询
 * @param {*} query
 */
export const subjectOne = (query) => {
  return request({
    url: `${prefix}/subject`,
    method: 'get',
    params: query
  })
}

/**
 * 科目创建
 * @param {*} query
 */
export const subjectCreate = (query) => {
  return request({
    url: `${prefix}/subject`,
    method: 'post',
    data: query
  })
}

/**
 * 科目修改
 * @param {*} query
 */
export const subjectUpdate = (query) => {
  return request({
    url: `${prefix}/subject`,
    method: 'put',
    data: query
  })
}

/**
 * 科目删除
 * @param {*} query
 */
export const subjectDestroy = (query) => {
  return request({
    url: `${prefix}/subject`,
    method: 'delete',
    data: query
  })
}

/**
 * 科目分类查询：列表
 * @param {*} query
 */
export const subjectCategoryList = (query) => {
  return request({
    url: `${prefix}/subject/category/list`,
    method: 'get',
    params: query
  })
}

/**
 * 科目分类查询
 * @param {*} query
 */
export const subjectCategoryOne = (query) => {
  return request({
    url: `${prefix}/subject/category`,
    method: 'get',
    params: query
  })
}

/**
 * 科目分类创建
 * @param {*} query
 */
export const subjectCategoryCreate = (query) => {
  return request({
    url: `${prefix}/subject/category`,
    method: 'post',
    data: query
  })
}

/**
 * 科目分类修改
 * @param {*} query
 */
export const subjectCategoryUpdate = (query) => {
  return request({
    url: `${prefix}/subject/category`,
    method: 'put',
    data: query
  })
}

/**
 * 科目分类删除
 * @param {*} query
 */
export const subjectCategoryDestroy = (query) => {
  return request({
    url: `${prefix}/subject/category`,
    method: 'delete',
    data: query
  })
}

/**
 * 教师查询：列表
 * @param {*} query
 */
export const teacherList = (query) => {
  return request({
    url: `${prefix}/teacher/list`,
    method: 'get',
    params: query
  })
}

/**
 * 教师查询
 * @param {*} query
 */
export const teacherOne = (query) => {
  return request({
    url: `${prefix}/teacher`,
    method: 'get',
    params: query
  })
}

/**
 * 教师创建
 * @param {*} query
 */
export const teacherCreate = (query) => {
  return request({
    url: `${prefix}/teacher`,
    method: 'post',
    data: query
  })
}

/**
 * 教师修改
 * @param {*} query
 */
export const teacherUpdate = (query) => {
  return request({
    url: `${prefix}/teacher`,
    method: 'put',
    data: query
  })
}

/**
 * 教师删除
 * @param {*} query
 */
export const teacherDestroy = (query) => {
  return request({
    url: `${prefix}/teacher`,
    method: 'delete',
    data: query
  })
}

/**
 * 院校专业查询：列表
 * @param {*} query
 */
export const collegeMajorList = (query) => {
  return request({
    url: `${prefix}/college/major/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校专业可关联查询：列表
 * @param {*} query
 */
export const collegeMajorUsableList = (query) => {
  return request({
    url: `${prefix}/college/major/usable/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校专业创建
 * @param {*} query
 */
export const collegeMajorCreate = (query) => {
  return request({
    url: `${prefix}/college/major`,
    method: 'post',
    data: query
  })
}

/**
 * 院校专业删除
 * @param {*} query
 */
export const collegeMajorDestroy = (query) => {
  return request({
    url: `${prefix}/college/major`,
    method: 'delete',
    data: query
  })
}

/**
 * 学院专业查询：列表
 * @param {*} query
 */
export const academyMajorList = (query) => {
  return request({
    url: `${prefix}/academy/major/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学院专业可关联查询：列表
 * @param {*} query
 */
export const academyMajorUsableList = (query) => {
  return request({
    url: `${prefix}/academy/major/usable/list`,
    method: 'get',
    params: query
  })
}

/**
 * 学院专业创建
 * @param {*} query
 */
export const academyMajorCreate = (query) => {
  return request({
    url: `${prefix}/academy/major`,
    method: 'post',
    data: query
  })
}

/**
 * 学院专业删除
 * @param {*} query
 */
export const academyMajorDestroy = (query) => {
  return request({
    url: `${prefix}/academy/major`,
    method: 'delete',
    data: query
  })
}

/**
 * 专业科目查询：列表
 * @param {*} query
 */
export const majorSubjectList = (query) => {
  return request({
    url: `${prefix}/majorSubject/list`,
    method: 'get',
    params: query
  })
}

/**
 * 专业科目可关联查询：列表
 * @param {*} query
 */
export const majorSubjectUsableList = (query) => {
  return request({
    url: `${prefix}/majorSubject/usable/list`,
    method: 'get',
    params: query
  })
}

/**
 * 专业科目创建
 * @param {*} query
 */
export const majorSubjectCreate = (query) => {
  return request({
    url: `${prefix}/majorSubject`,
    method: 'post',
    data: query
  })
}

/**
 * 专业科目删除
 * @param {*} query
 */
export const majorSubjectDestroy = (query) => {
  return request({
    url: `${prefix}/majorSubject`,
    method: 'delete',
    data: query
  })
}

/**
 * 图片文件上传token 七牛云
 * @param {*} query
 */
export const uploadImageToken = (query) => {
  return request({
    url: `${prefix}/upload/image/token`,
    method: 'get',
    params: query
  })
}

/**
 * 综合文件上传token 七牛云
 * @param {*} query
 */
export const uploadFileToken = (query) => {
  return request({
    url: `${prefix}/upload/file/token`,
    method: 'get',
    params: query
  })
}

/**
 * 资源创建
 * @param {*} query
 */
export const resourceCreate = (query) => {
  return request({
    url: `${prefix}/resource`,
    method: 'post',
    data: query
  })
}

/**
 * 资源修改
 * @param {*} query
 */
export const resourceUpdate = (query) => {
  return request({
    url: `${prefix}/resource`,
    method: 'put',
    data: query
  })
}

/**
 * 创建视频信息
 * @param {*} query
 */
export const videoInfoCreate = (query) => {
  return request({
    url: `${prefix}/videoInfo`,
    method: 'post',
    data: query
  })
}


/**
 * 金牌客服查询：列表
 * @param {*} query
 */
export const serviceList = (query) => {
  return request({
    url: `${prefix}/college/service/list`,
    method: 'get',
    params: query
  })
}

/**
 * 金牌客服查询
 * @param {*} query
 */
export const serviceOne = (query) => {
  return request({
    url: `${prefix}/college/service`,
    method: 'get',
    params: query
  })
}

/**
 * 金牌客服创建
 * @param {*} query
 */
export const serviceCreate = (query) => {
  return request({
    url: `${prefix}/college/service`,
    method: 'post',
    data: query
  })
}

/**
 * 金牌客服修改
 * @param {*} query
 */
export const serviceUpdate = (query) => {
  return request({
    url: `${prefix}/college/service`,
    method: 'put',
    data: query
  })
}

/**
 * 金牌客服删除
 * @param {*} query
 */
export const serviceDestroy = (query) => {
  return request({
    url: `${prefix}/college/service`,
    method: 'delete',
    data: query
  })
}


/**
 * 院校菜单查询：列表
 * @param {*} query
 */
export const collegeMenuList = (query) => {
  return request({
    url: `${prefix}/college/menu/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校菜单查询
 * @param {*} query
 */
export const collegeMenuOne = (query) => {
  return request({
    url: `${prefix}/college/menu`,
    method: 'get',
    params: query
  })
}

/**
 * 院校菜单创建
 * @param {*} query
 */
export const collegeMenuCreate = (query) => {
  return request({
    url: `${prefix}/college/menu`,
    method: 'post',
    data: query
  })
}

/**
 * 院校菜单修改
 * @param {*} query
 */
export const collegeMenuUpdate = (query) => {
  return request({
    url: `${prefix}/college/menu`,
    method: 'put',
    data: query
  })
}

/**
 * 院校菜单删除
 * @param {*} query
 */
export const collegeMenuDestroy = (query) => {
  return request({
    url: `${prefix}/college/menu`,
    method: 'delete',
    data: query
  })
}


/**
 * 图片上传
 * @param {*} query
 */
export const uploadImg = (query) => {
  return request({
    url: `${prefix}/upload/image`,
    method: 'post',
    data: query
  })
}


/**
 * 院校核心学院专业（查询列表）
 * @param {*} query
 */
export const corelist = (query) => {
  return request({
    url: `${prefix}/college/core/academyMajor/list`,
    method: 'get',
    params: query
  })
}

/**
 * 院校核心学院专业（查询详情）
 * @param {*} query
 */
export const coreOne = (query) => {
  return request({
    url: `${prefix}/college/core/academyMajor`,
    method: 'get',
    params: query
  })
}

/**
 * 院校核心学院（导出）
 * @param {*} query
 */
export const coreExport = (query) => {
  return request({
    url: `${prefix}/college/core/academyMajor/list/export`,
    method: 'get',
    params: query
  })
}


/**
 * 专业详情
 * @param {*} query
 */
// @@@@@@@@@  调不通
export const majorinfo = (query) => {
  return request({
    url: `${prefix}/major/info`,
    method: 'get',
    params: query
  })
}
/**
 * vod上传视频
 * @param {*} query
 */
export const uploadVideo = (query) => {
  return request({
    url: `${prefix}/upload/vod/video`,
    method: 'post',
    data: query
  })
}
/**
 * vod获取视频地址
 * @param {*} query
 */
export const videoPlayUrl = (query) => {
  return request({
    url: `${prefix}/vod/videoPlayUrl`,
    method: 'get',
    params: query
  })
}
/**
 * 微信获取研盒小程序链接
 * @param {*} query
 */

export const getUrl = (query) => {
  return request({
    url: `${prefix}/wechat/getUrlLinkSeniorMini`,
    method: 'post',
    data: query
  })
}








